export const enumerators = {
    AnnouncementType: {
        'CONCURSO_PUBLICO': 'Concurso Público',
        'ENEM': 'Enem',
        'VESTIBULAR': 'Vestibular',
        'RESIDENCIA_MEDICA': 'Residência Médica',
        'OAB': 'OAB',
        'CONCURSO_MILITAR': 'Concurso Militar',
        'OUTROS': 'Outros'
    },
    BrazilState: {
        'AC': 'Acre',
        'AL': 'Alagoas',
        'AP': 'Amapá',
        'AM': 'Amazonas',
        'BA': 'Bahia',
        'CE': 'Ceará',
        'DF': 'Distrito Federal',
        'ES': 'Espirito Santo',
        'GO': 'Goiás',
        'MA': 'Maranhão',
        'MT': 'Mato Grosso',
        'MS': 'Mato Grosso do Sul',
        'MG': 'Minas Gerais',
        'PA': 'Pará',
        'PB': 'Paraiba',
        'PR': 'Paraná',
        'PE': 'Pernambuco',
        'PI': 'Piauí',
        'RJ': 'Rio de Janeiro',
        'RN': 'Rio Grande do Norte',
        'RS': 'Rio Grande do Sul',
        'RO': 'Rondônia',
        'RR': 'Roraima',
        'SC': 'Santa Catarina',
        'SP': 'São Paulo',
        'SE': 'Sergipe',
        'TO': 'Tocantins',
        'FEDERAL': 'Federal'
    },
    ContactSubject: {
        'ANNOUNCEMENT': 'Sugestão de Edital',
        'FEEDBACK': 'Críticas e Sugestões',
        'PARTNERSHIPS': 'Parcerias e Colaborações',
        'SUPPORT': 'Suporte',
        'WORK_WITH_US': 'Oportunidade de Trabalho',
        'OTHERS': 'Outros'
    },
    ExamMethod: {
        'MULTIPLE_CHOICE': 'Múltipla Escolha',
        'TRUE_OR_FALSE': 'Certo/Errado'
    },
    InstituteJurisdiction: {
        'MUNICIPAL': 'Municipal',
        'ESTADUAL': 'Estadual',
        'FEDERAL': 'Federal',
        'PRIVADO': 'Privado'
    },
    OccupationScholarity: {
        'FUNDAMENTAL': 'Fundamental',
        'MEDIO': 'Médio',
        'TECNICO': 'Técnico',
        'SUPERIOR': 'Superior'
    },
    PlanStatusType: {
        'NOT_INIT': 'Não Iniciado',
        'STUDING': 'Estudando',
        'STUDIED': 'Estudado',
        'REMOVED': 'Removido'
    },
    PlanningType: {
        'SCHEDULE': 'Quadro de Horários',
        'CYCLE': 'Ciclo de Estudos',
        'MANUAL': 'Manual'
    },
    PlanningMethod: {
        'ESTUDEI': 'Método Estudei'
    },
    ReminderType: {
        'ANSWER_KEY': 'Simulados',
        'EVENTS': 'Eventos',
        'EXAMS': 'Provas',
        'OTHERS': 'Outros',
        'PAYMENTS': 'Pagamentos',
        'PUBLICATIONS': 'Publicações',
        'REGISTRATION': 'Inscrições',
        'REVIEWS': 'Revisões',
        'STUDIES': 'Estudos'
    },
    ReviewStatus: {
        'PENDING': 'Programada',
        'DELAYED': 'Atrasada',
        'IGNORED': 'Ignorada',
        'COMPLETED': 'Completa'
    },
    StudyCategory: {
        'STUDY': 'Teoria',
        'REVIEW': 'Revisão',
        'EXAM_QUESTIONS': 'Questões',
        'READING': 'Leitura de Lei',
        'JURISPRUDENCE': 'Jurisprudência'
    },
    SubscriberStatus: {
        'ACTIVE': 'Ativo',
        'PENDING': 'Pendente',
        'EXPIRED': 'Expirado',
        'CANCELED': 'Cancelado',
        'UNDER_REVIEW': 'Em Análise',
        'SUSPENDED': 'Suspenso',
        'INACTIVE': 'Inativo',
        'DELAYED': 'Atrasado',
        'CANCELLED_BY_CUSTOMER': 'Cancelado pelo Cliente',
        'CANCELLED_BY_SELLER': 'Cancelado pelo Vendedor',
        'CANCELLED_BY_ADMIN': 'Cancelado pelo Administrador',
        'STARTED': 'Iniciado',
        'OVERDUE': 'Vencido'
    },
    SubscriberProvider: {
        'HOTMART': 'Hotmart',
        'NONE': 'Nenhum',
        'APPLE': 'Apple',
    },
    SubscriberFields: {
        'name': 'Nome',
        'email': 'E-mail',
        'provider': 'Provedor',
        'externalId': 'Identificador',
        'createdAt': 'Data',
        'status': 'Status'
    },
    PaymentMethod: {
        'BILLET': 'Boleto',
        'CASH_PAYMENT': 'Pagamento em Dinheiro',
        'CREDIT_CARD': 'Cartão de Crédito',
        'DIRECT_BANK_TRANSFER': 'Transferência Bancária Direta',
        'DIRECT_DEBIT': 'Débito Direto',
        'FINANCED_BILLET': 'Boleto Financiado',
        'FINANCED_INSTALLMENT': 'Parcelamento Financiado',
        'FREE': 'Gratuito',
        'GOOGLE_PAY': 'Google Pay',
        'HOTCARD': 'Hotcard',
        'HYBRID': 'Híbrido',
        'MANUAL_TRANSFER': 'Transferência Manual',
        'PAYPAL': 'Paypal',
        'PAYPAL_INTERNACIONAL': 'Paypal Internacional',
        'PICPAY': 'Picpay',
        'PIX': 'Pix',
        'SAMSUNG_PAY': 'Samsung Pay',
        'WALLET': 'Carteira',
    },
    HotmartEvent: {
        'SUBSCRIPTION_CANCELLATION': 'Cancelamento de Assinatura',
        'SWITCH_PLAN': 'Troca de Plano',
        'UPDATE_SUBSCRIPTION_CHARGE_DATE': 'Atualização da Data de Cobrança',
        'PURCHASE_APPROVED': 'Compra Aprovada',
        'PURCHASE_PROTEST': 'Pedido de Reembolso',
        'PURCHASE_REFUNDED': 'Reembolso de Compra',
        'PURCHASE_CANCELED': 'Compra Cancelada',
        'PURCHASE_DELAYED': 'Compra Atrasada',
        'PURCHASE_EXPIRED': 'Compra Expirada',
        'PURCHASE_BILLET_PRINTED': 'Aguardando Pagamento',
        'PURCHASE_COMPLETE': 'Compra Completa',
        'PURCHASE_CHARGEBACK': 'Chargeback',
        'PURCHASE_OUT_OF_SHOPPING_CART': 'Compra Abandonada'
    },
    UserRole: {
        'ADMIN': 'Administrador',
        'STUDENT': 'Estudante',
        'SUPPORT': 'Suporte'
    },
    UserGender: {
        'MALE': 'Masculino',
        'FEMALE': 'Feminino',
        'UNINFORMED': 'Não Informado',
        'OTHER': 'Outro'
    }
};
